const originalConsoleTable = console.table;
const originalConsoleLog = console.log;

function areCookieBotPrefsAllowed() {
  const cookiebotEnabled = window["Cookiebot"] ? true : false,
    consent = window["Cookiebot"] ? window["Cookiebot"]["consent"]?.["preferences"] : false;
  if (cookiebotEnabled) if (!consent) return;
  return true;
}

window.__toggleConsoleLogs = function (toggleType) {
  switch (toggleType) {
    case "all":
      console.log = originalConsoleLog;
      console.table = originalConsoleTable;
      originalConsoleLog("All console logging enabled!");
      break;
    case "request":
      console.log = function () {};
      console.table = originalConsoleTable;
      originalConsoleLog("Request console logging enabled!");
      break;
    case "info":
      console.table = function () {};
      console.log = originalConsoleLog;
      originalConsoleLog("Info console logging enabled!");
      break;
    case "none":
      console.log = function () {};
      console.table = function () {};
      originalConsoleLog("Console logging disabled!");
      break;
    default:
      break;
  }

  const arePrefsAllowed = areCookieBotPrefsAllowed();
  const isLocalhost = window.location.hostname === "localhost";
  if (arePrefsAllowed || isLocalhost) {
    try {
      sessionStorage.setItem("__ltogglestate", toggleType);
    } catch (error) {}
  }
};

(function () {
  let toggleState;
  try {
    toggleState = sessionStorage.getItem("__ltogglestate");
  } catch (error) {}

  if (toggleState) {
    window.__toggleConsoleLogs(toggleState);
  } else {
    console.log = function () {};
    console.table = function () {};
  }
})();
